import React from "react";

const NewFeedVideoSponsor: React.FC<{
  sponsored: any;
  onOpenPostModal: (postId: string) => void;
}> = ({ sponsored, onOpenPostModal }) => {
  return sponsored ? (
    <div onClick={() => onOpenPostModal(`${sponsored.provider_post_id}`)}>
      <video
        src={sponsored.post_attachments[0].media_file_src}
        loop
        className="clip w-full rounded-lg"
        autoPlay
        muted
      />
    </div>
  ) : (
    <div></div>
  );
};

export default NewFeedVideoSponsor;
